import React, { useEffect } from 'react';

import './checkbox.css';


export const Checkbox = (props) => {
    return (
        <div className='checkbox-wrapper' onClick={(e) => {if (e.target.tagName === 'DIV') e.target.children[0].click();}}>
            <input {...props} type="checkbox" className={(props.className ?? '') + ' checkbox'} />
            <label>
                <svg viewBox='0 0 100 100'>
                    <path d="M 70 30 L 48 68 L 28 53"/>
                </svg>
            </label>
        </div>
    );
}